
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex'

@Options({
  props: {
    msg:String,
    AboutUs: String,
    AboutUsText: String,
    OurTeam: String,
    OurTeamText: String,
    OurProduct: String,
    OurProductText: String,
  },
  computed: {
    ...mapGetters(['getJsonData']),
    jsonData() {
      const jsonData = this.getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, "<br>");
      return JSON.parse(jsonDataWithBreaks);
    }
  }
})
export default class icon18plus extends Vue {
  msg!: string
}
